export default {
    amountLabel: 'ยอดค้างชำระ (บาท)',
    studentNo: 'รหัสนักเรียน',
    billingHistory: 'รายการชำระเงิน',
    pay: 'ชำระเงิน',
    receipt: 'ใบเสร็จ',
    notFound: 'ไม่พบรายการชำระ',
    invoice: 'ใบแจ้งหนี้',
    issueDate: 'วันที่ออก',
    dueDate: 'กำหนดรับชำระ',
    netAmount: 'มูลค่าสุทธิ',
    paidOn: 'วันที่ชำระ',
    status: 'สถานะ',
    paid: 'ชำระแล้ว',
    pending: 'รอชำระ',
    overdue: 'เกินเวลาชำระ',
    askedQuest: 'คำถามที่พบบ่อย'
}
